{
  "slug": "iq-score-ranges-explained",
  "title": "Rangos de puntuación de CI explicados",
  "description": "Explore las bandas comunes de puntuación de CI, percentiles aproximados, intervalos de confianza y los límites de las etiquetas.",
  "summary": "Las bandas de puntuación de CI son resúmenes convenientes, pero los límites y las etiquetas varían según la prueba, y las puntuaciones deben interpretarse como estimaciones y en contexto.",
  "sections": [
    {
      "heading": "Una guía práctica para los rangos comunes",
      "paragraphs": [
        "Para una escala con una media de 100 y la desviación estándar de 15, estas bandas proporcionan orientación general, no son categorías de diagnóstico."
      ],
      "bullets": [
        "130 y arriba: aproximadamente la parte superior 2%",
        "120–129: aproximadamente el 91st–9710º percentiles",
        "110–119: aproximadamente el 75th–9010º percentiles",
        "90–109: rango medio amplio",
        "80–89: aproximadamente el 9th–2410º percentiles",
        "70–79: aproximadamente el 2nd–810º percentiles",
        "Below 70: aproximadamente el más bajo. 2%"
      ]
    },
    {
      "heading": "Por qué las etiquetas difieren",
      "paragraphs": [
        "Los editores y las instituciones utilizan diferentes términos y límites, un resultado en un límite no es significativamente diferente de uno a un punto de distancia, y los intervalos de confianza a menudo cruzan más de una banda.",
        "Los resultados altos o bajos no deben interpretarse solo a partir del total, sino que un profesional debe considerar el funcionamiento adaptativo, el desarrollo, la educación y el lenguaje cuando sea relevante."
      ]
    },
    {
      "heading": "Lee el perfil, no solo el número",
      "paragraphs": [
        "Dos personas con la misma puntuación general pueden tener diferentes fortalezas, una puede sobresalir en el razonamiento verbal, mientras que otra puede tener un mejor rendimiento en los patrones visuales. Un compuesto puede ocultar estas diferencias.",
        "Usa una partitura en línea como una instantánea bajo condiciones particulares, no como una etiqueta permanente."
      ]
    }
  ],
  "faqs": [
    {
      "question": "¿Qué se considera un CI alto?",
      "answer": "En muchas escalas, 120 o superior está muy por encima de la media y 130 o por encima está alrededor de la parte superior 2%, pero la terminología varía."
    },
    {
      "question": "¿Son exactos los límites del rango de CI?",
      "answer": "El error de medición y los diferentes sistemas de clasificación hacen que los límites sean aproximados."
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
